import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import Icon from '../Icon';
export default function SelectSearch(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Input, {
    width: "auto",
    value: value,
    className: "jmtd-select-search",
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      className: "jmti-search"
    }),
    onChange: onChange
  });
}
SelectSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};
SelectSearch.defaultProps = {
  value: '',
  onChange: function onChange() {}
};